/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{resolveIncludes as e}from"./sources/resolver.js";const r={shaders:{vertexShader:e("tileInfo/tileInfo.vert"),fragmentShader:e("tileInfo/tileInfo.frag")},attributes:new Map([["a_pos",0]])};export{r as tileInfo};
